import { render, staticRenderFns } from "./BlockedEmailEdit.vue?vue&type=template&id=22c3532c&lang=pug"
import script from "./BlockedEmailEdit.vue?vue&type=script&lang=js"
export * from "./BlockedEmailEdit.vue?vue&type=script&lang=js"
import style0 from "./BlockedEmailEdit.vue?vue&type=style&index=0&id=22c3532c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports